export default {
  showSettingDialog(state, payload) {
    state.settingDialog = payload
  }
}
